<template>
  <div>
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               width="40%"
               top="5vh"
               :show-close="false"
               :title="$t('model.AddTask')">
      <div class="form-box">
        <el-form style="height:90%"
                 size="small"
                 label-position="left"
                 label-width="120px">
          <template class="moisture"
                    v-if="type === 2">
            <el-form-item :label="$t('model.MaxRh')"
                          label-width="20%">
              <el-slider show-input
                         :max="99"
                         :min="75"
                         v-model="form.MaxRh">
              </el-slider>
            </el-form-item>
            <el-form-item :label="$t('model.HoleDepth')">
              <el-input size="small"
                        v-model="form.DepthFromTopOfSlab"></el-input>
            </el-form-item>
          </template>
          <el-form-item :label="$t('model.Name')">
            <el-input size="small"
                      v-model="Name"
                      :placeholder="$t('model.Name')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('model.Type')">
            <el-select size="small"
                       :disabled="true"
                       v-model="type">
              <el-option v-for=" i of taskType"
                         :key="i.Key"
                         :label="$t('model.'+i.Value)"
                         :value="i.Key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.Status')">
            <el-select size="small"
                       v-model="form.Status">
              <el-option v-for=" i of taskStatus"
                         :key="i.Value"
                         :label="$t('api.'+i.Key)"
                         :value="i.Value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.TaskGroup')">
            <el-select size="small"
                       style="width:85%"
                       clearable
                       v-model="form.TaskPhaseId">
              <el-option v-for="i of taskGroup"
                         :key="i.PhaseId"
                         :label="i.Name"
                         :value="i.PhaseId"></el-option>
            </el-select>
            <el-button circle
                       type="primary"
                       size="small"
                       v-has="'Create Task Group'"
                       :title="$t('groupDialog.AddTaskGroup')"
                       style="position: absolute;top:50%;transform: translateY(-50%);right:0"
                       @click="openGroupDialog"><i class="el-icon-plus"></i></el-button>
          </el-form-item>
          <el-form-item :label="$t('model.StartDate')">
            <el-date-picker v-model="form.StartDate"
                            size="small"
                            :placeholder="$t('model.Select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('model.DueDate')">
            <el-date-picker v-model="form.EndDate"
                            size="small"
                            :placeholder="$t('model.Select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('model.Assignee')">
            <el-select @change="changeAssign"
                       size="small"
                       clearable
                       v-model="assign"
                       :placeholder="$t('model.SelectAssignee')">
              <el-option v-for="item in projectUser"
                         :key="item.UserId"
                         :label="item.FullName"
                         :value="item.UserId">
                <div class="user-logo">
                  <img :src="item.AvatarUrl"
                       alt="">
                </div>
                <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.Watching')">
            <el-select v-model="form.WatchingUserIds"
                       clearable
                       size="small"
                       multiple
                       :placeholder="$t('model.SelectWatching')">
              <el-option v-for="item in projectUser"
                         :key="item.UserId"
                         :label="item.FullName"
                         :value="item.UserId">
                <div class="user-logo">
                  <img :src="item.AvatarUrl"
                       alt="">
                </div>
                <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('taskDialog.Location')">
            <el-input v-model="locationText"
                      size="small"
                      :placeholder="$t('taskDialog.Location')"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="0">
                <el-upload ref="upload"
                           action=""
                           :multiple="true"
                           :limit="limit"
                           :accept="picAccept"
                           :auto-upload="false"
                           style="width:100%"
                           :show-file-list="false"
                           :file-list="allFileList"
                           :on-change="handlePicChange"
                           :on-success="handlePicSuccess"
                           :on-exceed="masterFileMax"
                           :http-request="postUpPic">
                  <el-button slot="trigger"
                             size="small"
                             style="width:100%"
                             type="primary">{{$t('taskDialog.AddPhoto')}}</el-button>
                </el-upload>
                <div class="pic-box"
                     :style="{height:picList.length>=4? height +'px':height}"
                     v-if="picList.length>0">
                  <myScroll style="width:94%;height:100%;margin:0 auto">
                    <el-table :data="picList"
                              :show-header="false">
                      <el-table-column width="55">
                        <i class="el-icon-document"></i>
                      </el-table-column>
                      <el-table-column>
                        <template slot-scope="scope">
                          {{scope.row.name}}
                        </template>
                      </el-table-column>
                      <el-table-column width="55">
                        <template slot-scope="scope">
                          <el-button size="small"
                                     circle
                                     @click="removePic(scope.$index)"
                                     type="danger">
                            <i class="el-icon-delete"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </myScroll>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item :label="$t('model.Description')">
            <el-input size="small"
                      v-model="form.Description"
                      type="textarea"
                      :placeholder="$t('model.DescribeTheTask')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="close">{{$t('model.Cancel')}}</el-button>
        <el-button type="primary"
                   @click="save"
                   :loading="btnLoading"
                   size="small">{{$t('model.Save')}}</el-button>
      </div>
    </el-dialog>
    <Group-Dialog :showDialog="groupDialog.showDialog"
                  :jobsiteId="form.JobsiteId"
                  @closeDialog="closeGroupDialog"></Group-Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GroupDialog from '@components/group/groupDialog'
import { uuid } from 'vue-uuid'
import { Upload } from '@/api/request'

import {
  addTask, getTaskCount
} from '@/api/config'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      btnLoading: false,
      groupDialog: {
        showDialog: false
      },
      form: {
        TaskPhaseId: '',
        Status: 'Open',
        MaxRh: 85,
        StartDate: new Date()
      },
      Name: '',
      assign: '',
      allFileList: [],
      picList: [],
      picAccept: '.jpg,.jpeg,.png,.gif,.bmp',
      limit: 9,
      taskId: '',
      locationText: '',
      height: 0
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'taskStatus', 'taskType', 'taskWorkType', 'taskGroup', 'projectUser'])
  },
  created () {
  },
  mounted () {
  },
  watch: {
    picList (to, from) {
      console.log(to)
      if (to.length > 5) {
        this.height = 200
      } else {
        this.height = 'auto'
      }
    },
    showDialog (to, from) {
      if (to) {
        this.form = {
          TaskPhaseId: '',
          Status: 'Open',
          MaxRh: 85,
          StartDate: new Date()
        }
        this.Name = ''
        this.assign = ''
        this.picList = []
        this.locationText = ''
        this.taskId = uuid.v4()
        this.btnLoading = false
        let query = {
          JobsiteId: this.jobsiteID,
          Type: this.type
        }
        getTaskCount(query).then(res => {
          let num = res
          if (this.type === 0 || this.type === 1) {
            this.Name = this.$t('model.task') + '-' + (num + 1)
          } else if (this.type === 2) {
            this.Name = this.$t('model.Probe') + '-' + (num + 1)
          }
        })
      }
    }
  },
  methods: {
    masterFileMax (files, fileList) {
      this.$message.warning(this.$t('upload.Pleaseuploadamaximumofphotos/videos', [this.limit]))
    },
    handlePicChange (file, fileList) {
      this.picList.push(file)
    },
    handlePicSuccess (file, fileList) {
      this.$refs.upload.clearFiles()
    },
    uploadingPic (file) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file.raw)
        formData.append('taskId', this.taskId)
        let url = '/api/TaskPhotos'
        Upload(url, formData).then(result => {
          resolve(1)
        })
      })
    },
    async postUpPic () {
      return new Promise(async (resolve, reject) => {
        let time = 0
        for (let i of this.picList) {
          if (i.size > 50000000) {
            this.$notify.closeAll()
            this.$notify({
              title: this.$t('api.WARNING'),
              message: this.$t('api.PhotoOrVideolargerthan50Mcannotbeuploaded'),
              showClose: false
            })
            this.btnLoading = false
            return
          }
          time += await this.uploadingPic(i)
        }
        if (time === this.picList.length) {
          resolve()
        }
      })
    },
    removePic (index) {
      this.picList.splice(index, 1)
      this.allFileList = this.picList
    },
    close (id) {
      if (id) {
        this.allFileList = []
        this.$emit('closeDialog', id)
      }
    },
    save () {
      this.btnLoading = true
      let array = []
      let obj = {}
      obj.taskId = this.taskId
      obj.TaskType = this.type
      obj.JobsiteId = this.jobsiteID
      obj.Name = this.Name
      obj.RoomId = ''
      this.form.TaskShapes = [{
        TaskId: obj.taskId,
        RoomShapeId: '0',
        ShapeArea: 0,
        ShapeId: '0',
        ShapeName: this.locationText,
        ShapePerimeter: 0,
        ShapeType: 0
      }]
      for (let i in this.form) {
        obj[i] = this.form[i]
      }
      array.push(obj)
      let params = array
      addTask(params).then(async res => {
        let taskIdList = []
        res.forEach(res => {
          if (!res.ParentTaskId) {
            taskIdList.push(res)
          }
        })
        if (taskIdList.length > 0) {
          // await this.postUpFile()
          await this.postUpPic()
          this.btnLoading = false
          this.close(taskIdList)
        } else {
          this.close()
        }
      }).catch(err => {
        this.btnLoading = false
        console.log(err)
      })
    },
    changeAssign () {
      this.form.AssignedUserIds = []
      if (this.assign.length < 1) {
        this.form.AssignedUserIds = []
      } else {
        this.form.AssignedUserIds.push(this.assign)
      }
    },
    closeGroupDialog (id) {
      if (id) {
        this.$store.dispatch('getTaskGroup').then(() => {
          this.$nextTick(() => {
            this.form.TaskPhaseId = id
          })
        })
      }
      this.groupDialog.showDialog = false
    },
    openGroupDialog () {
      this.groupDialog.showDialog = true
    }
  },
  components: {
    GroupDialog
  }
}
</script>
<style lang="scss">
.form-box {
  .el-upload {
    width: 100%;
  }
}
</style>
<style scoped lang='scss'>
.form-box {
  max-width: 500px;
  margin: 0 auto;
  overflow: hidden;
  .pic-box {
    overflow: hidden;
    width: 100%;
  }
}
.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
